/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

import { is } from 'immutable';
// @ts-expect-error - Remove once type definitions are available
import { getType } from '../../../common-message-format/operators/commonMessageFormatGetters';
import { MESSAGE_ID_ATTR } from '../../../web/message-history/constants/constants';
// @ts-expect-error - Remove once type definitions are available
import { getMessageId } from '../../../message-history/operators/getMessageId';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const shouldRerender = (prev, next) => {
  return !Object.keys(prev).some(key => {
    if (key === 'fileAttachments' || key === 'positionDescriptors' || key === 'senders') {
      return !is(prev[key], next[key]);
    }
    // @ts-expect-error Leaving exisitng logic in place while converting to TS to prevent as many runtime changes as possible. Issue to fix: https://github.com/HubSpotEngineering/context-and-collab-projects/issues/1654
    return prev[key] !== next[key];
  });
};
const MessageHistoryItem = /*#__PURE__*/memo(({
  allowContactPromotions,
  fileAttachments,
  fileAttachmentsForThread,
  friendlyNames,
  indexedAsyncFileAttachments,
  hiddenBy,
  historyConfig,
  message,
  portalId,
  positionDescriptors,
  presentSenderLocators,
  senders,
  legacyRecipients,
  visitorLastReadTimestamp,
  vid,
  visitorRecipients,
  threadId,
  ungatedForNewForkedComponent,
  ungatedForOmnichannelCallSummaryAiSkill,
  ungatedForUnifiedCallSummary,
  ungatedForSDPPublicBetaURR,
  isUngatedForExpandCollapse,
  isUngatedForRethinkAttachments,
  channelName,
  slots,
  isLastMessage
}) => {
  const idAttr = {
    [MESSAGE_ID_ATTR]: getMessageId(message)
  };
  const type = getType(message);
  const Component = historyConfig[type];

  // Components here are oversubscribed to props they don't care about. Components should pick the explicit props they need and ignore the rest
  // Idea: Update InboxConfig to specify a list of props for each component, then ONLY those are passed in (even if more are generated behind the scenes)
  // We could add some monitoring to determine if a message component is passed a prop it doesn't need, and whittle the number down over time
  return Component ? /*#__PURE__*/_jsx("div", Object.assign({}, idAttr, {
    children: /*#__PURE__*/_jsx(Component, {
      allowContactPromotions: allowContactPromotions,
      channelName: channelName,
      fileAttachments: fileAttachments,
      fileAttachmentsForThread: fileAttachmentsForThread,
      friendlyNames: friendlyNames,
      hiddenBy: hiddenBy,
      indexedAsyncFileAttachments: indexedAsyncFileAttachments,
      message: message,
      portalId: portalId,
      positionDescriptors: positionDescriptors,
      senders: senders,
      legacyRecipients: legacyRecipients,
      presentSenderLocators: presentSenderLocators,
      visitorLastReadTimestamp: visitorLastReadTimestamp,
      vid: vid,
      visitorRecipients: visitorRecipients,
      threadId: threadId,
      ungatedForNewForkedComponent: ungatedForNewForkedComponent,
      ungatedForOmnichannelCallSummaryAiSkill: ungatedForOmnichannelCallSummaryAiSkill,
      ungatedForUnifiedCallSummary: ungatedForUnifiedCallSummary,
      ungatedForSDPPublicBetaURR: ungatedForSDPPublicBetaURR,
      isUngatedForExpandCollapse: isUngatedForExpandCollapse,
      isUngatedForRethinkAttachments: isUngatedForRethinkAttachments,
      slots: slots,
      isLastMessage: isLastMessage
    })
  })) : null;
}, shouldRerender);
MessageHistoryItem.displayName = 'MessageHistoryItem';
export default MessageHistoryItem;